<template>
	<div v-if="isFixedStart" class="w-100">
		<div class="d-flex flex-row align-items-center justify-content-center h-50 gap-10">
			<div style="width: 100%">{{ FormMSG(1, 'Member of team') }}</div>
		</div>
	</div>
	<div v-else>
		<div class="d-flex flex-row align-items-center justify-content-center h-50 gap-10">
			<div style="width: 100%">
				<div>{{ item.label.split` `[0] }}</div>
				<div>{{ item.label.split` `[1] }}</div>
			</div>
		</div>
	</div>
</template>
<script>
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
export default {
	name: 'HeaderRowTables',
	mixins: [languageMessages, globalMixin],
	props: {
		isFixedStart: {
			type: Boolean,
			required: false
		},
		item: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},
	data: () => ({})
};
</script>
